module.exports = __webpack_public_path__ + "img/光荣榜.22276d52.png";